const type = {
  NEW: '신규',
  ACH: '기관변경',
  YR3: '정기(3년)',
  YR1: '1년주기',
  MOV: '공장이전',
  MCH: '주요자재변경',
  RPS: '지위승계신청',
  AIT: '품목추가',
  MAP: '생산중단',
  MAR: '생산재개',
  ASP: '종류·등급·호칭 또는 모델추가',
  REV: 'KS개정,인증심사기준개정',
  CHK: '확인심사',
  RCK: '재심사',
  SPE: '특별현장조사',
  ACK: '인증서재발급',
  ACE: '영문인증서발급',
};

const typeForJudge = {
  NEW: '신규',
  ACH: '기관변경',
  YR3: '정기(3년)',
  YR1: '1년주기',
  MOV: '공장이전',
  AIT: '품목추가',
  ASP: '종류·등급·호칭 또는 모델추가',
  CHK: '확인심사',
  RCK: '재심사',
  SPE: '특별현장조사',
};

const charge = {
  C: '업체',
  A: '인증담당자',
  O: '행정요원',
  D: '인증책임자',
  J: '인증심사원',
  M: '인증위원',
  S: '회원관리자',
  V: '조회전용',
};

const qnaCategory = {
  PAY: '결제문의',
  JUDGE: '심사문의',
};

const faqCategory = {
  PAY: '결제문의',
  JUDGE: '심사문의',
};

const csCategory = {
  poor: '불량KS인증제품신고',
  weak: '부실심사신고',
  dissatisfaction: '업무처리 불만신고',
};

const infoCategory = {
  form: '각종서식',
  etc: '기타',
};

const level = {
  A: '심사신청',
  P: '심사준비',
  J: '공장심사',
  C: '위원회심의',
  F: '심의후처리',
  X: '취소',
};

// N:정기심사요청 ,A: 심사신청, P: 심사준비, J: 심사, C: 위원회심의

const recheck = {
  Y: '확인심사',
  R: '재심사',
};

export default {
  type, status, charge, qnaCategory, level, csCategory, infoCategory, faqCategory, recheck, typeForJudge,
};



// WEBPACK FOOTER //
// ./src/constants/code.js